import {useMemo, useState} from 'react'
import {Tooltip, Grid, Button,} from "@material-ui/core";
import Toolbar from "@material-ui/core/Toolbar";
import clsx from "clsx";
import ExcelFile from "@ibrahimrahmani/react-export-excel/dist/ExcelPlugin/components/ExcelFile";
import ExcelSheet from "@ibrahimrahmani/react-export-excel/dist/ExcelPlugin/elements/ExcelSheet";
import ExcelColumn from "@ibrahimrahmani/react-export-excel/dist/ExcelPlugin/elements/ExcelColumn";
import {isEmpty} from "lodash";
import {lighten, makeStyles} from "@material-ui/core/styles";
import {isNotEmpty} from "../../shared/functions/types_check";
import {useInventory} from "../../context/InventoryContext";
import {Card, CardContent, Stack, Typography} from "@mui/material";
import GridOnIcon from "@material-ui/icons/GridOn";
import AutoFixOffIcon from '@mui/icons-material/AutoFixOff';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import ProductionQuantityLimitsIcon from '@mui/icons-material/ProductionQuantityLimits';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import MessagePrompt from "../_customs/MessagePrompt";
import InventoryPdfExport from "./InventoryPdfExport";
import useToggle from "../../shared/functions/useToggle";
import ItemsAutoComplete from "../_customs/ItemsAutoComplete";
import {useDispatch} from "react-redux";
import {getInventory, getItemInventory} from 'src/redux/slices/inventory/inventory.thunks'
import CreateOrders from "../orders/fragments/CreateOrders";
import AddQuantity from '../orders/fragments/AddQuantity';
import TextField from "@material-ui/core/TextField";
import DateFnsUtils from '@date-io/date-fns'; 
import FilterListIcon from '@material-ui/icons/FilterList';
import ArtTrackTwoToneIcon from '@mui/icons-material/ArtTrackTwoTone';
import {isFunction} from "lodash";

import FilterProductToPurchaseModal from './FilterProductToPurchaseModal';

import {
  DatePicker,
  TimePicker,
  DateTimePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';


import {VendorSelect} from "../../shared/components/VendorSelect"; 
import CreateCart from './CreateCart';


const useToolbarStyles = makeStyles((theme) => ({
    root: {
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
    },
    highlight:
        theme.palette.type === 'light'
            ? {
                color: theme.palette.primary.main,
                backgroundColor: lighten(theme.palette.primary.light, 0.85),
                border: 0,
            }
            : {
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.primary.dark,
            },
    title: {
        flex: '1 1 50%',
    },
}));

export default function  InventoryDataGridToolbar({numSelected, selectedItem = [], onFilterChange = null, setVendorId = null}) {
    
    const dispatch = useDispatch();
    const [selected, setSelected] = useState(null)
    const [my_vendor_id, setMyVendorId] = useState("")
    const {open, handleClose, handleOpen} = useToggle()
    const {open: isCreateModalOpen, handleClose: handleOrderClose, handleOpen: handleOrderOpen} = useToggle()
    const {open: isCreateCartModalOpen, handleClose: handleCartClose, handleOpen: handleCartOpen} = useToggle()
    const {open: isCreateModalQuantityOpen, handleClose: handleQuantityClose, handleOpen: handleQuantityOpen} = useToggle()
    const classes = useToolbarStyles();
    const {hide, filters, addToCartForFutureOder} = useInventory();
    const [selectedDate, handleDateChange] = useState(new Date());
    const [isFilterModalShown, setIsFilterModalShown] = useState(false); 

    const handleDate2Change = (value) => {
        handleDateChange(value) 
        var month = value.getMonth()+1
        var filterbyData = value.getDate()+"-"+month+"-"+value.getFullYear()

        var date = new Date(filterbyData)

        var goodDAte = month +"-"+value.getDate()+"-"+value.getFullYear() 

        dispatch(getInventory(null, false, 100, null, new Date(goodDAte)))
    }


    const handleSelection = selected => {

        if (selected) {
            dispatch(getItemInventory(filters, selected?.id))
            // console.log(selectedItem?.hasToBuy)
        } else {
            dispatch(getInventory(filters))
            // console.log(selectedItem?.hasToBuy)
        }

        setSelected(selected)
        // console.log(selectedItem?.hasToBuy)
    }

    
    const handleFilterModalClosing = () => {
        setIsFilterModalShown(false)
    };

    const handleFilterChange = (filter) => {
        dispatch(getInventory(filters, false, 100, null,  ""))
    }
    const handleFilterModalShowing = () => {
        setIsFilterModalShown(true)
    }

    

    const handleDisable = () => hide(selectedItem?.map(one => one?.id)) 

    const handleAddToCart = () => addToCartForFutureOder(selectedItem) 
    
    const handleCreateOrderModalClosing = () => {
        handleOrderClose()
    }
    const handleCreateCartModalClosing = () => {
        handleCartClose()
    }
    const handleCreateQuantityModalClosing = () => {
            handleQuantityClose()
    }
   
    const exportData = useMemo(() => selectedItem?.map(item => {
        
        const totalShipping = item?.shipping?.map(one => Number(one?.quantity));
        const totalS = (isEmpty(totalShipping) ? [0] : totalShipping)?.reduce((a, b) => a + b)

        const totalPos = item?.pos?.map(one => Number(one?.quantity));
        const totalP = (isEmpty(totalPos) ? [0] : totalPos)?.reduce((a, b) => a + b)
        return ({
            ...item,
            totalP,
            totalS,
            oDekon: (item?.Stock?.Dekon || 0) <= 0,
            oCassablanca: (item?.Stock?.Cassablanca || 0) <= 0,
            sDekon: item?.Stock?.Dekon || 0,
            sCassablanca: item?.Stock?.Cassablanca || 0,
            sellPrice: item?.SellPrice || item?.Price || item?.NewPrice || 0,
        })
    }), [selectedItem])

    const exportCommandeData = useMemo(() => selectedItem?.map(item => {
        var Vendor_id = ""
        var ComposeFilter = JSON.parse(localStorage.getItem('ComposeFilter'))
        if (ComposeFilter && ComposeFilter.delivery.vendor !== null){ 
            Vendor_id = ComposeFilter.delivery.vendor.id
        }
        setMyVendorId(Vendor_id) 

        var ItemCode = item?.Vendors ? (item?.Vendors === null ? "" : (item?.Vendors[Vendor_id]?.ItemCode ?? "")) : ""

        var VendorItemName = item?.VendorItemName ? item?.VendorItemName : ""
        var ItemSize = item?.ItemSize ? item?.ItemSize : ""
        var VendorItemPackOf = item?.VendorItemPackOf ? item?.VendorItemPackOf : ""
        var VendorItemUnit = item?.VendorItemUnit ? item?.VendorItemUnit : ""
        

        
        
        const totalShipping = item?.shipping?.map(one => Number(one?.quantity));
        const totalS = (isEmpty(totalShipping) ? [0] : totalShipping)?.reduce((a, b) => a + b)

        const totalPos = item?.pos?.map(one => Number(one?.quantity));
        const totalP = (isEmpty(totalPos) ? [0] : totalPos)?.reduce((a, b) => a + b)
        return ({
            ...item,
            totalP,
            totalS,
            oDekon: (item?.Stock?.Dekon || 0) <= 0,
            oCassablanca: (item?.Stock?.Cassablanca || 0) <= 0,
            sDekon: item?.Stock?.Dekon || 0,
            sCassablanca: item?.Stock?.Cassablanca || 0,
            sellPrice: item?.SellPrice || item?.Price || item?.NewPrice || 0,
            ItemCode: ItemCode,
            VendorItemName: VendorItemName,
            ItemSize: ItemSize,
            VendorItemPackOf: VendorItemPackOf,
            VendorItemUnit: VendorItemUnit,
        })
    }), [selectedItem])

    // console.log(selectedItem)

    // const filterToBuy = useMemo( () => selectedItem?.map(item  => {
    //     const filterB =  item?.
    // }) )

    const orders = useMemo(() => {
        const products = selectedItem?.map(({id, Barcode, ImageUrl, InternalId, Name}) => ({
            Id: id,
            Barcode,
            ImageUrl,
            InternalId,
            Name,
            Quantity: {
                Bought: 0,
                Ordered: 0
            }
        }))
        
        return {
            Items: products || null,
            ItemIds: products?.map(one => one?.Id) || null,
            Purchaser: null,
            Issuer: null,
            Order: {
                State: "pending",
                Comment: "",
                OrderedAt: new Date(),
                Deadline: new Date()
            }
        }
    }, [selectedItem])

    /*
    const handleFilter = (action) => {  
        localStorage.setItem('VendorId', action);
 
        isFunction(setVendorId) && setVendorId(action)
        dispatch(getInventory(filters, false, 100, null,  action))
    }*/


    // console.log(selectedItem)
    // console.log(selectedItem[0]?.hasToBuy)



    return (
        <section style={{marginBottom: 20}}>

            <Toolbar className={clsx(classes.root, {[classes.highlight]: numSelected > 0})}
                     style={{borderRadius: 20,}}>
                {
                    isNotEmpty(selectedItem) && (
                        <Grid container
                              style={{paddingLeft: 20, paddingRight: 20, justifyContent: 'space-between'}}>
                            <Grid item>
                                <Typography variant={'h6'} style={{paddingTop: 4}}>
                                    {`Séléctionnés :  ${numSelected}`}
                                </Typography>
                            </Grid>
                            <Grid item>
                                <Stack direction={'row'}>
                                
                                    {/* <Tooltip title={'Qunatité a la Commande'}>
                                        <Button startIcon={<ProductionQuantityLimitsIcon/>} onClick={handleQuantityOpen} data={selectedItem}>
                                        QUANTITY FOR MONTH
                                        </Button>
                                    </Tooltip> */
                                    
                                    }
                                    {
                                        my_vendor_id == "1KYKgga9y3Z7tBbBR66J" ? // JINNY BSA
                                        <ExcelFile
                                        element={
                                            <Tooltip title={'Exporter en excel'}>
                                                <Button startIcon={<GridOnIcon/>}>
                                                    Excel Commande JINNY BSA
                                                </Button>
                                            </Tooltip>
                                        }
                                    >
                                        <ExcelSheet data={exportCommandeData} name="ORDER">
                                            <ExcelColumn label="ITEM ID" value="ItemCode"/>
                                            <ExcelColumn label="DESCRIPTION" value="VendorItemName"/>  
                                            <ExcelColumn label="ITEM SIZE" value="ItemSize"/>  
                                            <ExcelColumn label="# / CASE" value="VendorItemPackOf"/>  
                                            <ExcelColumn label="QTY ORDERED" value=""/>  
                                            <ExcelColumn label="UOM" value="VendorItemUnit"/>
                                        </ExcelSheet>
                                    </ExcelFile> : ""
                                    }
                                    {
                                        
                                        my_vendor_id == "0gpwqXZKJYy8dhY8FAoQ" ? // EBD GROUP
                                        <ExcelFile
                                        element={
                                            <Tooltip title={'Exporter en excel'}>
                                                <Button startIcon={<GridOnIcon/>}>
                                                    Excel Commande EBD GROUP
                                                </Button>
                                            </Tooltip>
                                        }
                                    >
                                        <ExcelSheet data={exportCommandeData} name="ORDER"> 
                                            <ExcelColumn label="DESCRIPTION" value="Name"/>  
                                            <ExcelColumn label="SIZE" value=""/>
                                            <ExcelColumn label="ORDER QTY EACH" value=""/>  
                                            <ExcelColumn label="UNIT" value=""/>
                                        </ExcelSheet>
                                    </ExcelFile> : ""
                                    }
                                    {
                                        
                                        my_vendor_id == "0AupBbm4r6Vd0anrzXg1" ? // FISK INSDUSTRIES
                                        <ExcelFile
                                        element={
                                            <Tooltip title={'Exporter en excel'}>
                                                <Button startIcon={<GridOnIcon/>}>
                                                    Excel Commande FISK INSDUSTRIES
                                                </Button>
                                            </Tooltip>
                                        }
                                    >
                                        <ExcelSheet data={exportCommandeData} name="ORDER"> 
                                            <ExcelColumn label="CODE" value="ItemCode"/>
                                            <ExcelColumn label="DESIGNATION" value="Name"/>  
                                            <ExcelColumn label="QUANTITY" value=""/>   
                                        </ExcelSheet>
                                    </ExcelFile> : ""
                                    }
                                    {
                                        
                                        my_vendor_id == "FBtKxl5dEACefblO3fSG" ? // BEAUTY 21
                                        <ExcelFile
                                        element={
                                            <Tooltip title={'Exporter en excel'}>
                                                <Button startIcon={<GridOnIcon/>}>
                                                    Excel Commande BEAUTY 21
                                                </Button>
                                            </Tooltip>
                                        }
                                    >
                                        <ExcelSheet data={exportCommandeData} name="ORDER"> 
                                            <ExcelColumn label="CODE" value="ItemCode"/> 
                                            <ExcelColumn label="Q" value=""/>   
                                        </ExcelSheet>
                                    </ExcelFile> : ""
                                    }
                                    

                                    <ExcelFile
                                        element={
                                            <Tooltip title={'Exporter en excel'}>
                                                <Button startIcon={<GridOnIcon/>}>
                                                    Excel
                                                </Button>
                                            </Tooltip>
                                        }
                                    >
                                        <ExcelSheet data={exportData} name="Reciving">
                                            <ExcelColumn label="Prosoft Id" value="InternalId"/>
                                            <ExcelColumn label="Code barre" value="Barcode"/>
                                            <ExcelColumn label="Nom Produit" value="Name"/>
                                            <ExcelColumn label="SellPrice" value="sellPrice"/>
                                            <ExcelColumn label="Stock Dekon" value="sDekon"/>
                                            <ExcelColumn label="Stock Cassablanca" value="sCassablanca"/>
                                            <ExcelColumn label="Dekon out of stock" value="oDekon"/>
                                            <ExcelColumn label="Cassablanca out of stock" value="oCassablanca"/>
                                            <ExcelColumn label="Qt. in Po" value="totalP"/>
                                            <ExcelColumn label="Qt. in shipping" value="totalS"/>
                                        </ExcelSheet>
                                    </ExcelFile>

                                    <Tooltip title={'Exporter en pdf'}>
                                        <Button startIcon={<PictureAsPdfIcon/>} onClick={handleOpen}>
                                            Pdf
                                        </Button>
                                    </Tooltip>

                                    <Tooltip title={'Commande des produits'}>
                                        <Button startIcon={<AddShoppingCartIcon/>} onClick={handleOrderOpen}>
                                            Commander
                                        </Button>
                                    </Tooltip> 

                                    <Tooltip title={'Add to Cart'}>
                                        <Button startIcon={<AddShoppingCartIcon/>} onClick={handleCartOpen}>
                                            Add to Cart
                                        </Button>
                                    </Tooltip>


                                    <Tooltip title={'Cacher les produits sélectionnées'}>
                                        <MessagePrompt
                                            text={'Vous êtes sur le point de désactiver ce Produit, Continuer ? '}
                                            onConfirm={handleDisable}
                                            color={'error'}
                                            element={(
                                                <Button startIcon={<AutoFixOffIcon/>}>
                                                    Disable
                                                </Button>
                                            )}
                                        />

                                    </Tooltip>

                                </Stack>

                            </Grid>
                        </Grid>
                    )
                }

                {
                    isEmpty(selectedItem) && (
                            <Grid container spacing={2}>
                                <Grid item xs={6}>
                                    
                                <Card>
                                    <CardContent style={{padding: 0}}>
                                        {/*<TextField*/}
                                        {/*    value={keyword}*/}
                                        {/*    label={"Rechercher par nom, code barre, prosoft id"}*/}
                                        {/*    variant={"outlined"}*/}
                                        {/*    onChange={({target: {value}}) => setKeyword(value)}*/}
                                        {/*    size={'small'}*/}
                                        {/*    style={{*/}
                                        {/*        width: 500,*/}
                                        {/*    }}*/}
                                        {/*/>*/}
                                        <ItemsAutoComplete value={selected} onChange={handleSelection} minWidth={700}/>

                                    </CardContent>
                                    
                                </Card>
                                </Grid>
                                <Grid item xs={4}>
                                    {
                                        /*
                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                            <DatePicker value={selectedDate} onChange={handleDate2Change}  />
                                        </MuiPickersUtilsProvider>*/
                                    }
                                </Grid>
                                {
                                    /*
                                     
                                <Grid item xs={3}>
                                    <VendorSelect setValidationStatus={handleFilter}/>
                                </Grid>
                                     */
                                }
                                {/* <Grid item xs={1}>
                                <Button onClick={handleFilterModalShowing}>
                                    <FilterListIcon/>
                                    {' Filter'}
                                </Button>
                                </Grid>
                                <Grid item xs={1}>
                                <Button onClick={handleFilterModalShowing}>
                                    <ArtTrackTwoToneIcon/>
                                    {' card'}
                                </Button>
                                </Grid> */}
                            </Grid>
                        
                        
                    )
                }

            </Toolbar>

            {/* {
                isCreateModalQuantityOpen && (
                    <AddQuantity show={isCreateModalQuantityOpen}  itemData={selectedItem} onClose={handleCreateQuantityModalClosing}/>

                )
            } */}

            <FilterProductToPurchaseModal 
                show={isFilterModalShown}
                onSet={handleFilterChange}
                onClose={handleFilterModalClosing}
            />


            <InventoryPdfExport open={open} onClose={handleClose} data={selectedItem}/>
            {
                isCreateModalOpen && (
                    <CreateOrders show={isCreateModalOpen} orderData={orders} onClose={handleCreateOrderModalClosing}/>
                )
            }
            {
                isCreateCartModalOpen && (
                    <CreateCart show={isCreateCartModalOpen} orderData={selectedItem} onClose={handleCreateCartModalClosing}/>
                )
            }
        </section>
    )

}